import { ApiClient } from 'api/RestClient';
import { BlogRVO } from 'types/lang/main/BlogRVO';
import { doFetch } from 'util/AxiosUtil';

export const selectBlogList = async () => {
  return doFetch<BlogRVO[]>(ApiClient, '/api/blog/list').then((res) => res.data);
};
